import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import CountryCard from "components/Screens/Setting/CountryDetails/CountryCard";
import SettingsLayout from "components/Screens/Setting/SettingsLayout/SettingsLayout";
import PageLoader from "components/common/PageLoader";

import { getAllCountriesLeavePolicies } from "services/useTimeoffService";

import { COUNTRIES_URL_MAPPING } from "components/Screens/Setting/constants";
import { TIME_OFF_ROUTES } from "constants/routes";

import "./TimeOff.scss";

function TimeOff() {
  const navigate = useNavigate();
  const [countriesData, setCountriesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCountriesData = async () => {
      try {
        setLoading(true);
        const { data = [], success } = await getAllCountriesLeavePolicies();
        const formattedData = [];
        if (success && data) {
          data.forEach(({ policyCount = 0, employeeCount = 0, country }) => {
            formattedData.push({
              country,
              policyCount,
              employeeCount,
            });
          });
        }

        setCountriesData(formattedData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCountriesData();
  }, []);

  const handleCountryClick = (country) => {
    navigate(TIME_OFF_ROUTES.COUNTRY_DETAIL(COUNTRIES_URL_MAPPING[country]));
  };

  return (
    <SettingsLayout title="Time Off" linkName="Time Off" link={TIME_OFF_ROUTES.BASE}>
      <div className="timeoff-main-container">
        <div className="countries-section">
          <div className="countries-title heading-h4-semibold color-text-heading-primary">Countries</div>
          {error && <div className="timeoff-loading">{error}</div>}
          {loading ? (
            <div className="timeoff-loading">
              <PageLoader />
            </div>
          ) : (
            <div className="countries-grid">
              {countriesData.map(({ country, policyCount = 0, employeeCount = 0 }) => (
                <CountryCard
                  key={country}
                  country={country}
                  onClick={handleCountryClick}
                  policies={policyCount}
                  employees={employeeCount}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </SettingsLayout>
  );
}

export default TimeOff;
